import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@mui/material';
import { usePromotions } from '@/store';
import { yupResolver } from '@hookform/resolvers/yup';
import { getYupObject, getFields } from '@/locales/forms';
import { useForm } from 'react-hook-form';
import { FormsWrapper, FormText } from '../../components/forms';
import {
  filterInputStringUpperCaseWithOutSpaces,
  onlyLettersAndNumbers,
} from '../../utils/formatString';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import useUserTracking from '@/hooks/userTracking';

function PromotionForm({ onSubmit = () => {} }) {
  const { t } = useTranslation();
  const fields = getFields();
  const yup = getYupObject();
  const schema = yup
    .object({
      code: fields.code.validation,
    })
    .required();

  const resolver = yupResolver(schema);
  const { getPromotion } = usePromotions();
  const { promotionAdded, promotionError } = useAnalyticsEvents();
  const form = useForm({
    mode: 'onChange',
    ...{ resolver },
  });

  const { couponApplied } = useUserTracking();

  const {
    formState: { isValid },
    setError,
  } = form;

  const onSubmitHandler = async (form) => {
    const resp = await getPromotion(form.code);

    if (resp === 'total_zero') {
      onSubmit();
    }

    if (!resp) {
      promotionError(form.code);
      setError('code', {
        type: 'custom',
        message: t('checkout.coupons.invalid'),
      });
    } else {
      promotionAdded(form.code);
      couponApplied({
        code: resp?.code,
        discount: resp?.discont_amount,
        type: resp?.discount_type,
      });
      onSubmit();
    }
  };

  return (
    <FormsWrapper form={form} onSubmit={onSubmitHandler}>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <FormText
            autofocus
            {...fields.code.form}
            size="small"
            transform={(i) =>
              filterInputStringUpperCaseWithOutSpaces(i, onlyLettersAndNumbers)
            }
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={!isValid}
          >
            {t('checkout.buttons.apply')}
          </Button>
        </Grid>
      </Grid>
    </FormsWrapper>
  );
}

export default PromotionForm;
